import { 
  FETCH_FACILITIES_SUCCESS, 
  FETCH_FACILITIES_FAILURE, 
  FETCH_FACILITIES_LOADING,
  SET_SELECTED_FACILITY,
  FACILITY_SWITCH_LOADING
} from "../types/type";
import { fetchFacilityByList } from "../../services/facility/facility";
import { closeAllTabs } from "./tab.action";

export const fetchFacilities = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_FACILITIES_LOADING });
    try {
      const data = await fetchFacilityByList();
      
      // Handle different response formats
      let facilityList = [];
      if (data && Array.isArray(data)) {
        facilityList = data;
      } else if (data && data.data && Array.isArray(data.data)) {
        facilityList = data.data;
      } else if (data && typeof data === 'object') {
        // If data is an object with items, try to extract array
        facilityList = Object.values(data).filter(item => Array.isArray(item))[0] || [];
      }
      
      dispatch({
        type: FETCH_FACILITIES_SUCCESS,
        payload: facilityList || []
      });
    } catch (error) {
      console.error("Error fetching facilities:", error);
      dispatch({
        type: FETCH_FACILITIES_FAILURE,
        payload: error?.message || "Failed to fetch facilities"
      });
    }
  };
};


export const setSelectedFacility = (facility) => {
  return async (dispatch) => {

    dispatch({ type: FACILITY_SWITCH_LOADING, payload: true });

    setTimeout(() => {

      // 1️⃣ Save facility in redux
      dispatch({
        type: SET_SELECTED_FACILITY,
        payload: facility
      });

      // 2️⃣ Save facility in localStorage
      localStorage.setItem("selectedFacility", JSON.stringify(facility));

      dispatch(closeAllTabs());

      dispatch({ type: FACILITY_SWITCH_LOADING, payload: false });

    }, 400);
  };
};


// export const setSelectedFacility = (facility) => {
//   return {
//     type: SET_SELECTED_FACILITY,
//     payload: facility
//   };
// };

